import { useEffect, useRef } from 'react';

export default function MarqueeText() {
  const slideRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const copy = slideRef.current.cloneNode(true);
    containerRef.current.appendChild(copy);
  }, []);

  const features = [
    "Instant Approval",
    "Loans up to ₹20 Lakhs",
    "100% Digital Process",
    "Low Interest Rates",
    "Quick Disbursal",
    "Minimal Documentation",
    "Secure & Private",
    "Flexible Tenure",
    "24x7 Support"
  ];

  return (
    <div className="logos mt-[25px] mb-2 sm:mt-[60px]" ref={containerRef}>
      <div className="logos-slide" ref={slideRef}>
        {features.map((text, i) => (
          <span key={i} className="marquee-text text-[18px] sm:text-[28px] ">
            {text}
          </span>
        ))}
      </div>

      <style jsx>{`
        * {
          box-sizing: border-box;
        }

        .logos {
          overflow: hidden;
          font-family:'myFirstFont6';
       
          
          white-space: nowrap;
          position: relative;
        }

        .logos:before,
        .logos:after {
          content: '';
          position: absolute;
          top: 0;
          width: 250px;
          height: 100%;
          z-index: 2;
        }

        .logos:before {
          left: 0;
          background: linear-gradient(to left, rgba(255, 255, 255, 0), white);
        }

        .logos:after {
          right: 0;
          background: linear-gradient(to right, rgba(255, 255, 255, 0), white);
        }

        .logos-slide {
          display: inline-block;
          animation: slide 15s linear infinite;
        }

        .logos:hover .logos-slide {
          animation-play-state: paused;
        }

        .marquee-text {
          display: inline-block;
          
          color:#FFFFFF;
          margin: 0 40px;
        }

        @keyframes slide {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </div>
  );
}
